export default "__VITE_ASSET__DaS5F0UW__"